/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between a bit and a byte?`)
};

const es_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre un bit y un byte?`)
};

const de_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen einem Bit und einem Byte?`)
};

const nl_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen een bit en een byte?`)
};

const fr_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre un bit et un octet ?`)
};

const it_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra un bit e un byte?`)
};

const pt_br2_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre um bit e um byte?`)
};

const pt_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre um bit e um byte?`)
};

const ja_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビットとバイトの違いは何ですか?`)
};

const zh_uc_data_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq2_q", locale)
	if (locale === "en") return en_uc_data_faq2_q(inputs)
	if (locale === "es") return es_uc_data_faq2_q(inputs)
	if (locale === "de") return de_uc_data_faq2_q(inputs)
	if (locale === "nl") return nl_uc_data_faq2_q(inputs)
	if (locale === "fr") return fr_uc_data_faq2_q(inputs)
	if (locale === "it") return it_uc_data_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq2_q(inputs)
	if (locale === "pt") return pt_uc_data_faq2_q(inputs)
	if (locale === "ja") return ja_uc_data_faq2_q(inputs)
	return zh_uc_data_faq2_q(inputs)
};